/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import VeeValidate from 'vee-validate';
import Vue from 'vue';

/**
 * Validator initialisation module.
 *
 * Initialises and adds custom validation rules to vee-validate Validator.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

// add vee-validation components
Vue.use(VeeValidate, {fieldsBagName: 'formFields'});




